export default __webpack_public_path__ + "static/media/keke_headshot.28110c66.jpg";